import React, {useState} from 'react';
import ArrSlider from '../../../components/common/arr-slider/ArrSlider';

const ArrSliderDemo: React.FC = () => {
  const [sliderValue, setSliderValue] = useState(50);

  return (
    <ArrSlider
      value={sliderValue}
      onChange={setSliderValue}
      min={1}
      max={100}
      step={1}
      ariaLabel="Demo Slider"
      label="Precision Sensitivity"
      showInput
    />
  );
};

export default ArrSliderDemo;
